import { Currency } from '@models/ropolo';

const mapCurrencyLabel = (inputCurrency?: Currency, compact?: boolean, locale: string = 'fa') => {
  switch (inputCurrency) {
    case Currency.RIAL:
      return locale === 'fa' ? 'ریال' : 'rial';

    default:
      if (compact) {
        return locale === 'fa' ? 'ت' : 't';
      }
      return locale === 'fa' ? 'تومان' : 'toman';
  }
};

const getCurrencyConversionRate = (inputCurrency?: Currency) => {
  switch (inputCurrency) {
    case Currency.RIAL:
      return 10;
    default:
      return 1;
  }
};

const formatPrice = ({
  price = 0,
  currency = Currency.TOMAN,
  showZero = false,
  locale = 'fa',
}: {
  price?: number;
  currency?: Currency;
  showZero: boolean;
  locale?: string;
}) => {
  let showPrice = price;

  if (currency === Currency.RIAL) {
    showPrice = price * 10;
  }

  const isFree = showPrice === 0;

  // eslint-disable-next-line no-nested-ternary
  const zero = showZero ? '0' : locale === 'fa' ? 'رایگان' : 'Free';
  const formattedPrice = isFree ? zero : showPrice.toLocaleString();

  return formattedPrice;
};

const currencyUtil = { mapCurrencyLabel, formatPrice, getCurrencyConversionRate };

export default currencyUtil;
